<template lang="pug">
component.v-action(v-if="action" :is="action.link ? 'a' : 'button'" :href="action.link ? action.link : null" :type="action.link ? null : 'button'" :class="action.className" @click="handlerClick(action)")
	slot(name="icon")
	| {{action.text}}
	slot
	teleport(to="body")
		v-modal(v-if="(action.modalMessage || action.form) && openModal" @close="() => this.openModal = null" :data="{closeText: action.closeText}")
			.text-guide(v-if="action.modalMessage" v-html="action.modalMessage")
			template(v-else-if="action.form")
				v-form-message(v-if="action.form.message" :message="action.form.message" @action="() => {action.form.message = null; openModal = false}")
				v-form(v-else :form="action.form" @response="handlerResponse" :bxajaxid="action.form.bxajaxid" :hide-message="true")

</template>

<script>

import controller from "../scripts/controller/controller.js";

export default {
	props: {
		action: {
			type: Object,
			default: null
		}
	},

	data() {
		return {
			openModal: null
		}
	},

	methods: {
		handlerClick(action) {
			if (action.scrollToId) {
				controller.events.emit('scrollToId', action.scrollToId);
			} else if (action.modalMessage || action.form) {
				this.openModal = true;
			} else if (action.openCookies) {
				controller.events.emit('openCookies');
			}
		},

		handlerResponse(res) {
			this.action.form = res;
		}
	}
}

</script>